import React from 'react';
import { useHistory } from 'react-router-dom';
import { dashboardTabs } from '../../constants/options';
import { getSearchParameter } from '../../utils/urlFunctions';
import { NavBar } from '../../components';

const DashboardNavBar = () => {
  const history = useHistory();
  const currentPath = history.location.pathname;
  const transferableParams = ['restaurantUuid', 'timeInterval', 'today'];
  
  const onChange = newPath => {
    if (newPath !== currentPath) {
      const newTab = newPath.split('/').pop();
      
      const searchParams = transferableParams.reduce((acc, param) => {
        const paramValue = getSearchParameter(param);
      
        if (paramValue) {
          const divider = acc !== '' ? '&' : '?';
          let fullSearchParam = `${param}=${paramValue}`;
        
          return acc + divider + fullSearchParam;
        }
      
        return acc;
      }, '');
    
      history.push(newTab + searchParams);
    }
  };
  
  return (
    <NavBar
      itemWidth="85px"
      navTabs={dashboardTabs}
      activeTab={currentPath}
      onChange={onChange}
    />
  );
};

export default DashboardNavBar;